var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIndicators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2578_18367",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2578_18367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9C4 8.45 4.19583 7.97917 4.5875 7.5875C4.97917 7.19583 5.45 7 6 7C6.55 7 7.02083 7.19583 7.4125 7.5875C7.80417 7.97917 8 8.45 8 9C8 9.55 7.80417 10.0208 7.4125 10.4125C7.02083 10.8042 6.55 11 6 11C5.45 11 4.97917 10.8042 4.5875 10.4125C4.19583 10.0208 4 9.55 4 9ZM4 15C4 14.45 4.19583 13.9792 4.5875 13.5875C4.97917 13.1958 5.45 13 6 13C6.55 13 7.02083 13.1958 7.4125 13.5875C7.80417 13.9792 8 14.45 8 15C8 15.55 7.80417 16.0208 7.4125 16.4125C7.02083 16.8042 6.55 17 6 17C5.45 17 4.97917 16.8042 4.5875 16.4125C4.19583 16.0208 4 15.55 4 15ZM10 9C10 8.45 10.1958 7.97917 10.5875 7.5875C10.9792 7.19583 11.45 7 12 7C12.55 7 13.0208 7.19583 13.4125 7.5875C13.8042 7.97917 14 8.45 14 9C14 9.55 13.8042 10.0208 13.4125 10.4125C13.0208 10.8042 12.55 11 12 11C11.45 11 10.9792 10.8042 10.5875 10.4125C10.1958 10.0208 10 9.55 10 9ZM10 15C10 14.45 10.1958 13.9792 10.5875 13.5875C10.9792 13.1958 11.45 13 12 13C12.55 13 13.0208 13.1958 13.4125 13.5875C13.8042 13.9792 14 14.45 14 15C14 15.55 13.8042 16.0208 13.4125 16.4125C13.0208 16.8042 12.55 17 12 17C11.45 17 10.9792 16.8042 10.5875 16.4125C10.1958 16.0208 10 15.55 10 15ZM16 9C16 8.45 16.1958 7.97917 16.5875 7.5875C16.9792 7.19583 17.45 7 18 7C18.55 7 19.0208 7.19583 19.4125 7.5875C19.8042 7.97917 20 8.45 20 9C20 9.55 19.8042 10.0208 19.4125 10.4125C19.0208 10.8042 18.55 11 18 11C17.45 11 16.9792 10.8042 16.5875 10.4125C16.1958 10.0208 16 9.55 16 9ZM16 15C16 14.45 16.1958 13.9792 16.5875 13.5875C16.9792 13.1958 17.45 13 18 13C18.55 13 19.0208 13.1958 19.4125 13.5875C19.8042 13.9792 20 14.45 20 15C20 15.55 19.8042 16.0208 19.4125 16.4125C19.0208 16.8042 18.55 17 18 17C17.45 17 16.9792 16.8042 16.5875 16.4125C16.1958 16.0208 16 15.55 16 15Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIndicators);
export default __webpack_public_path__ + "static/media/DragIndicators.0118ef3355b7aaa58fa12cec6d2bd4df.svg";
export { ForwardRef as ReactComponent };